<section role="region">
  <header role="banner" class="form-input__header">
    <p *ngIf="question.title" class="form-input__header__title" [innerHTML]="title"></p>
    <p *ngIf="question.subtitle" class="form-input__header__subtitle" [innerHTML]="subtitle"></p>
  </header>

  <mat-form-field class="form-input__field form-input__field--textarea">
    <mat-label>{{ label || 'Votre réponse' }}</mat-label>
    <textarea
      #input
      type="text"
      [id]="elm_id"
      [name]="elm_id"
      [formControl]="control"
      [placeholder]="placeholder"
      [required]="required"
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="4"
      cdkAutosizeMaxRows="6"
      (keyup.enter)="next(control)"
    ></textarea>

    <mat-error *ngIf="control?.errors?.required">
      {{ errorMsg || 'Veuillez sélectionner une valeur' }}
    </mat-error>
  </mat-form-field>

  <footer class="form-input__actions">
    <button
      class="btn"
      type="button"
      (click)="next(control)"
      [attr.aria-label]="'Valider la question: ' + question.ariaLabel"
    >
      Valider
    </button>
    <button
      *ngIf="!required"
      class="btn-clean"
      type="button"
      (click)="skipQuestion.emit(control)"
      [attr.aria-label]="'Passer la question: ' + question.ariaLabel"
    >
      Passer
    </button>
  </footer>
</section>
